import {useAnalyticsSession} from "@mytour/platform";

/**
 * Null-render container mounting the analytics session watcher (identify,
 * onboarding funnel milestones, scoped session replay) — same pattern as
 * SentryContainer.
 */
export function AnalyticsContainer() {
  useAnalyticsSession();
  return null;
}
